<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-account-school
            </v-icon>
            <span class="title">Data Dosen</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Dosen
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="filter.jurusan"
                        :items="jurusanlist"
                        item-value="id_jur"
                        item-text="nama_jur"
                        label="Jurusan">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="filter.prodi"
                        :items="prodilist"
                        item-value="id_prodi"
                        item-text="nama_prodi"
                        label="Prodi">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="filter.search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn
                        large
                        block
                        :color="maincolor"
                        class="mt-1 white--text"
                        @click="getDosen">
                        <v-icon left dark>search</v-icon>
                        Cari
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <div class="text-center" v-if="loading.getdata">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-data-table
                        v-if="!loading.getdata"
                        :headers="headers"
                        :items="datalist"
                        :search="filter.search">
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            @click="editdosen(item)"
                            small
                            icon>
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            @click="deletedosen(item)"
                            small
                            icon>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAdd"
                    ref="formaddberita"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row justify="center" no-gutters>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="addberita.prodi_dosen"
                              :items="prodilist"
                              item-value="id_prodi"
                              item-text="nama_prodi"
                              label="Prodi"
                              :rules="[rules.required]">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="addberita.nip_dosen"
                              :rules="[rules.required]"
                              label="NIP"
                              name="nip_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="addberita.nama_dosen"
                              :rules="[rules.required]"
                              label="Nama"
                              name="nama_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select
                              :items="listjabatan"
                              name="jabatan_dosen"
                              v-model="addberita.jabatan_dosen"
                              label="Jabatan"
                              :rules="[rules.required]">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="addberita.email_dosen"
                              :rules="[rules.required]"
                              label="Email"
                              name="email_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="addberita.hp_dosen"
                              :rules="[rules.required]"
                              label="Handphone"
                              name="hp_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="addberita.alamat_dosen"
                              :rules="[rules.required]"
                              label="Alamat"
                              name="alamat_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-file-input
                              v-model="addberita.pic_dosen"
                              :rules="rules.files"
                              accept=".png, .jpg, .jpeg"
                              name="pic_dosen"
                              placeholder="Select file"
                              label="Image Thumbnail (max. 500 Kb)"
                              show-size
                              prepend-icon="mdi-camera">
                            </v-file-input>
                          </v-col>
                          <v-col cols="12">
                            <vue-editor
                              v-model="addberita.profile_dosen"
                              placeholder="Tuliskan profile dosen disini..."
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            <alertsp :alertdata="alertdata"></alertsp>
                            <v-btn
                              large
                              block
                              :disabled="!formadd.valid"
                              :color="maincolor"
                              dark
                              class="mr-4 mt-5"
                              type="submit">
                              Simpan
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.berita"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.berita">
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update data dosen
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('berita')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="12">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdate"
                    ref="formupdateberita"
                    v-model="formupdate.valid"
                    lazy-validation>
                    <v-row justify="center">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.berita.prodi_dosen"
                              :items="prodilist"
                              item-value="id_prodi"
                              item-text="nama_prodi"
                              label="Prodi"
                              :rules="[rules.required]">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              :items="listjabatan"
                              name="jabatan_dosen"
                              v-model="dmodaldata.berita.jabatan_dosen"
                              label="Jabatan"
                              :rules="[rules.required]">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.berita.nip_dosen"
                              :rules="[rules.required]"
                              label="NIP"
                              name="nip_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.berita.nama_dosen"
                              :rules="[rules.required]"
                              label="Nama"
                              name="nama_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.berita.email_dosen"
                              :rules="[rules.required]"
                              label="Email"
                              name="email_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.berita.hp_dosen"
                              :rules="[rules.required]"
                              label="Handphone"
                              name="hp_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="dmodaldata.berita.alamat_dosen"
                              :rules="[rules.required]"
                              label="Alamat"
                              name="alamat_dosen"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <vue-editor
                              v-model="dmodaldata.berita.profile_dosen"
                              placeholder="Tuliskan profile dosen disini..."
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              v-if="dmodaldata.berita.pic_dosen"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="api + '/upload/dosen/' + dmodaldata.berita.pic_dosen"
                              contain>
                            </v-img>
                            <v-img
                              v-if="!dmodaldata.berita.pic_dosen"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="require('../../assets/default.jpg')"
                              contain>
                            </v-img>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="dmodaldata.berita.pic_dosennew"
                              :rules="rules.files"
                              accept=".png, .jpg, .jpeg"
                              name="fileresume"
                              placeholder="Select file"
                              label="Image Thumbnail (max. 500 Kb)"
                              show-size
                              prepend-icon="mdi-camera">
                            </v-file-input>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              :items="liststatus"
                              name="status_dosen"
                              v-model="dmodaldata.berita.status_dosen"
                              label="Status dosen">
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <alertsp :alertdata="alertupdate"></alertsp>
                            <v-btn
                              block
                              large
                              :disabled="loading.update || !formupdate.valid"
                              :loading="loading.update"
                              :color="maincolor"
                              dark
                              type="submit">
                              Simpan
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- delete -->
    <v-dialog
      v-model="dmodal.delberita"
      max-width="450px">
      <v-card v-if="dmodaldata.delberita">
        <v-card-title>
          <span>Hapus data info</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.delberita = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah anda yakin menghapus data dosen? <br>
            <b>{{ dmodaldata.delberita.nama_dosen }}<br>({{ dmodaldata.delberita.nip_dosen }})</b>
            <!-- <span class="green--text" v-html="msgcopy"></span> -->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2 mb-3"
            color="error"
            dark
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemove(dmodaldata.delberita)">
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';

export default {
  name: 'DosenAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      remove: false,
      update: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    listjabatan: ['Ketua Jurusan', 'Koordinator Prodi', 'Dosen'],
    liststatus: ['active', 'passive'],
    listtype: ['berita', 'agenda', 'pengumuman', 'file'],
    listlang: ['id', 'en'],
    listcategory: ['pnb', 'pendidikan', 'penelitian', 'pengabdian', 'kerjasama', 'mahasiswa', 'bali', 'covid', 'pendaftaran', 'pkkmb', 'zi-wbk'],
    listfav: ['tidak', 'ya'],
    filter: {
      search: '',
      status: 'active',
      jurusan: '',
      prodi: '',
    },
    headers: [
      { text: 'NIP', value: 'nip_dosen', width: 150 },
      { text: 'Nama', value: 'nama_dosen' },
      { text: 'Jabatan', value: 'jabatan_dosen' },
      { text: 'Email', value: 'email_dosen' },
      { text: 'Status', value: 'status_dosen', width: 100 },
      { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 90 },
    ],
    prodilist: [],
    jurusanlist: [],
    datalist: [],
    addberita: {
      prodi_dosen: '',
      nip_dosen: '',
      prodi_dosen: '',
      jabatan_dosen: 'Dosen',
      nama_dosen: '',
      email_dosen: '',
      hp_dosen: '',
      alamat_dosen: '',
      profile_dosen: '',
      pic_dosen: null,
      status_dosen: 'active',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 200 || 'Max 200 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      berita: false,
      delberita: false,
    },
    dmodaldata: {
      berita: null,
      delberita: null,
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addtglberita: false,
      addtglevent: false,
      updatetglberita: false,
      updatetglevent: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJurusan();
    // this.getBerita();
    this.addberita.type_berita = this.listtype[0];
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    updateDate() {
      this.datepick.addtglberita = false;
      if (Date.parse(this.addberita.tgl_berita) > Date.parse(this.addberita.tgl_end)) {
        this.addberita.tgl_end = this.addberita.tgl_berita;
      }
    },
    updateDateEvent() {
      this.datepick.updatetglberita = false;
      if (Date.parse(this.dmodaldata.berita.tgl_berita) > Date.parse(this.dmodaldata.berita.tgl_end)) {
        this.dmodaldata.berita.tgl_end = this.dmodaldata.berita.tgl_berita;
      }
    },
    getJurusan() {
      if (this.tokenscr) {
        this.jurusanlist = [];
        this.axios
          .get(
            this.api + '/api/jurusan/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // kelurahan
                this.jurusanlist = resdata.data;
                this.filter.jurusan = this.jurusanlist[0].id_jur;
                // get banjar
                this.getProdi();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getProdi() {
      if (this.tokenscr) {
        this.prodilist = [];
        this.axios
          .get(
            this.api + '/api/prodi/',
            {
              params: {
                idpos: this.filter.jurusan,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.prodilist = resdata.data;
                // default
                this.filter.prodi = resdata.data[0].id_prodi;
                this.addberita.prodi_dosen = resdata.data[0].id_prodi;
                // get data
                this.getDosen();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getDosen() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/dosen/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    getBerita() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/berita/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddberita.validate()) {
        if (this.tokenscr) {
          const dataadd = this.addberita;
          const formData = new FormData();
          // console.log(this.addberita);
          // file image
          formData.append('pic_dosen', dataadd.pic_dosen);
          // data olga
          formData.append('alamat_dosen', dataadd.alamat_dosen);
          formData.append('email_dosen', dataadd.email_dosen);
          formData.append('hp_dosen', dataadd.hp_dosen);
          formData.append('jabatan_dosen', dataadd.jabatan_dosen);
          formData.append('nama_dosen', dataadd.nama_dosen);
          formData.append('nip_dosen', dataadd.nip_dosen);
          formData.append('prodi_dosen', dataadd.prodi_dosen);
          formData.append('profile_dosen', dataadd.profile_dosen);
          formData.append('status_dosen', dataadd.status_dosen);
          this.axios
            .post(
              this.api + '/api/dosen/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddberita.reset();
                  this.addberita.profile_dosen = '';
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Dosen "' + resdata.data + '" berhasil ditambahkan!';
                  this.getDosen();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'berita') {
        this.dmodal.berita = false;
      } else {
        this.dmodal.berita = false;
      }
    },
    editdosen(item) {
      this.dmodal.berita = true;
      this.alertupdate.show = false;
      this.dmodaldata.berita = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdateberita.validate()) {
        if (this.tokenscr) {
          this.loading.update = true;
          const dataadd = this.dmodaldata.berita;
          const formData = new FormData();
          // file
          formData.append('pic_dosennew', dataadd.pic_dosennew);
          // data
          // console.log(dataadd);
          formData.append('nip_dosen', dataadd.nip_dosen);
          formData.append('prodi_dosen', dataadd.prodi_dosen);
          formData.append('jabatan_dosen', dataadd.jabatan_dosen);
          formData.append('nama_dosen', dataadd.nama_dosen);
          formData.append('email_dosen', dataadd.email_dosen);
          formData.append('hp_dosen', dataadd.hp_dosen);
          formData.append('alamat_dosen', dataadd.alamat_dosen);
          formData.append('profile_dosen', dataadd.profile_dosen);
          formData.append('pic_dosen', dataadd.pic_dosen);
          formData.append('status_dosen', dataadd.status_dosen);
          formData.append('id_dosen', dataadd.id_dosen);
          this.axios
            .post(
              this.api + '/api/dosen/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Data dosen "' + this.dmodaldata.berita.nama_dosen + '" berhasil diubah!';
                  this.getDosen();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.loading.update = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.loading.update = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    deletedosen(item) {
      this.dmodal.delberita = true;
      this.alertupdate.show = false;
      this.dmodaldata.delberita = JSON.parse(JSON.stringify(item));
    },
    confirmRemove(item) {
      // console.log(item);
      this.alertupdate.show = false;
      if (this.tokenscr && item) {
        // console.log(item);
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/dosen/' + item.id_dosen,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.delberita = false;
                this.dmodaldata.delberita = null;
                this.getDosen();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token, please refresh first!';
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
